import React from "react";
import { Helmet } from "react-helmet";
import { Default } from "../layouts/default";
import "../../css/termsandconditions.css";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | BookVenue India</title>
        <meta
          name="description"
          content="Review BookVenue terms and conditions for using our sports venue booking platform and booking grounds, turfs, and courts online. "
        />
      </Helmet>
      <Default>
        <section className="policy-page terms-page">
          <div className="bv-container">
            <div className="policy-shell">
              <div className="policy-header">
                <span className="policy-eyebrow">Platform Rules</span>
                <h1 className="policy-title">Terms & Conditions</h1>
                <p className="policy-subtitle">
                  Welcome to BookVenue. By using our platform to book sports
                  venues online, you agree to the following terms.
                </p>
              </div>

              <div className="policy-content terms-card">
                  <div className="terms-block">
                    <h2>Platform Usage</h2>
                    <ul className="steps">
                      <li>Users must provide accurate information</li>
                      <li>
                        Users should be 18+ or use the platform under
                        supervision
                      </li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>Booking Policy</h2>
                    <ul className="steps">
                      <li>All bookings depend on venue availability</li>
                      <li>Prices may vary based on time and demand</li>
                      <li>
                        Booking is confirmed only after successful payment
                      </li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>Cancellation & Refund</h2>
                    <ul className="steps">
                      <li>Cancellation depends on the venue policy</li>
                      <li>Refund timelines may vary</li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>User Responsibilities</h2>
                    <ul className="steps">
                      <li>Users must follow venue rules</li>
                      <li>Any illegal activity is strictly prohibited</li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>Payments</h2>
                    <ul className="steps">
                      <li>All payments are processed securely</li>
                      <li>
                        BookVenue is not responsible for payment failures caused
                        by banks or gateways
                      </li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>Liability</h2>
                    <p>BookVenue is a platform connecting users with venues.</p>
                    <p>We are not responsible for:</p>
                    <ul className="steps">
                      <li>Venue conditions</li>
                      <li>Injuries, losses, or damages during bookings</li>
                    </ul>
                  </div>

                  <div className="terms-block">
                    <h2>Account Suspension</h2>
                    <p>
                      Accounts may be suspended in case of misuse or fraudulent
                      activity.
                    </p>
                  </div>

                  <div className="terms-block">
                    <h2>Updates</h2>
                    <p>We may update these terms at any time.</p>
                  </div>

                  <div className="terms-block support-box">
                    <h2>Contact</h2>
                    <p>
                      For any queries, email:
                      <strong>
                        <Link to="mailto:admin@bookvenue.app">
                          admin@bookvenue.app
                        </Link>
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
        </section>
      </Default>
    </>
  );
};

export default TermsAndConditions;
